import { LegacyRef, useRef } from 'react';
import { useSelector } from 'react-redux';
import { EIconSize } from 'utils/constants/app/ui';
import { GlobalIcon } from 'components/GlobalIcon';
import { Portal } from 'components/Shared/Portal';
import { getTurnstileEnabled } from 'store/selectors/app-data';

export const TurnstileCheck = () => {
  const turnstileEnabled = useSelector(getTurnstileEnabled);
  const container: LegacyRef<HTMLDivElement> = useRef(null);
  const wrapper: LegacyRef<HTMLDivElement> = useRef(null);

  return turnstileEnabled ? (
    <Portal>
      <div className="turnstile-container" ref={container}>
        <div className="turnstile-container__icon">
          <GlobalIcon
            lib="generic"
            name="close"
            theme="default"
            size={EIconSize._16}
            onClick={() => {
              if (container.current) {
                container.current.style.display = 'none';
              }

              if (wrapper.current) {
                wrapper.current.innerHTML = '';
              }
            }}
          />
        </div>

        <div
          id="turnstileWrapper"
          className="turnstile-wrapper"
          ref={wrapper}
        />
      </div>
    </Portal>
  ) : null;
};
